import {global} from './utils/globals';
global.probe = {};
